export default {
      id: "elastic-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#elastic-usage",
      toString: function () {
        return this.url;
      }
    }